import Modal from '@mui/material/Modal';
import clsx from 'clsx';
import React from 'react';

import TheInformationLogo from 'images/the-information-logo.svg';

interface TIModalProps {
  children: React.ReactNode;
  customHeader?: boolean;
  disableScrollLock?: boolean;
  id?: string;
  isFullScreen?: boolean;
  isOpen: boolean;
  onClose: () => void;
  parentClass?: string;
  withLogo?: boolean;
}

const TIModal = ({
  children,
  id,
  isFullScreen = false,
  isOpen,
  onClose,
  parentClass,
  withLogo = false,
  disableScrollLock,
  customHeader = false,
}: TIModalProps) => {
  return (
    <Modal open={isOpen} onClose={onClose} disableScrollLock={disableScrollLock} id={id}>
      <div
        className={clsx(
          'TIModal',
          'absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 z-[1000] rounded-2 max-h-full',
          parentClass,
          {
            'h-screen max-w-full xs:h-auto': isFullScreen,
            'h-auto px-16 max-w-full': !isFullScreen,
          }
        )}
      >
        <div
          className={clsx('modal-container bg-background-white', {
            'justify-start h-full xs:justify-center xs:h-auto': isFullScreen,
            'justify-center h-auto': !isFullScreen,
          })}
        >
          {!customHeader ? (
            <>
              <button className="close-button" onClick={onClose}></button>
              <div className="wrapper">
                {withLogo && (
                  <div className="logo-header">
                    <img src={TheInformationLogo} width={225} />
                  </div>
                )}
                {children}
              </div>
            </>
          ) : (
            <>{children}</>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TIModal;
